import React, { useContext } from 'react';

import { RicosViewerContext } from './../../ricos-context';
import type { HTMLData } from './../../ricos-schema/next-schema';
import type { NodeViewRendererProps } from './../../ricos-types';

import { HTML_TYPE } from '../types';
import { HtmlViewer } from './html-viewer';

const Html = ({ node, nodeIndex, NodeViewContainer }: NodeViewRendererProps) => {
  const { iframeSandboxDomain, config } = useContext(RicosViewerContext);

  return (
    <NodeViewContainer node={node} nodeIndex={nodeIndex}>
      <HtmlViewer
        htmlData={node.htmlData as HTMLData}
        settings={config[HTML_TYPE]}
        iframeSandboxDomain={iframeSandboxDomain}
        isViewer
      />
    </NodeViewContainer>
  );
};

export default Html;
